import { ReactNode } from 'react';

import { ITheme } from '@shared/models/theme';

export interface ILeaseholdDetail {
  comment: string | null;
  expiry_month: string | null;
  expiry_year: string | null;
}

export enum EventTypes {
  // Society Events
  Society = 0,
  // Transaction Date
  SignatureDate = 10,
  // Lease Dates
  LeaseStart = 11,
  LeaseEnd = 12,
  // Lease Events
  LeaseBreak = 13,
  LeaseRentReview = 14,
  LeaseRentFree = 15,
  LeaseRentReduced = 16,
  LeaseSteppedRent = 17,
  // Sale Events
  SaleCompletionDate = 20,
  // Viewings
  Viewing = 30,
}

export interface IdNameItem<T = number> {
  id: T;
  name: string;
}

export interface KeyLabelItem<T = number> {
  key: T;
  label: string;
}

export interface LookupContactItem extends IdNameItem {
  company_name: string | null;
  email: string | null;
  mobile_number: string | null;
  phone_number: string | null;
}

export interface LookupUserItem extends IdNameItem {
  image: string;
  organisationName: string | null;
  theme: ITheme;
}

export interface SpaceItem {
  count?: number;
  divider?: boolean;
  dot?: boolean;
  icon: ReactNode;
  id: string;
  name: string; // NOTE: We may show name later
  tooltip?: string;
}

export interface AmenitiesSpecificationsDTO {
  [key: string]: string | null;
}
